import { ReviewOutcomeSummary } from '@/components/common/ReviewDecision';
import { PENDING_SUBMISSION_STATUS } from '../constants/instituteSubmission.constants';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { Can } from '@/components/common/Can';
import type { InstituteSubmissionDetail } from '../types/instituteSubmission.types';
import { InstituteSubmissionReviewActions } from './InstituteSubmissionReviewActions';

interface InstituteSubmissionReviewPanelProps {
  submission: InstituteSubmissionDetail;
}

export function InstituteSubmissionReviewPanel({
  submission,
}: InstituteSubmissionReviewPanelProps) {
  if (submission.status === PENDING_SUBMISSION_STATUS) {
    return (
      <Can code={FIELD_OPS_PERMISSIONS.INSTITUTE_SUBMISSION_REVIEW}>
        <InstituteSubmissionReviewActions submission={submission} />
      </Can>
    );
  }

  return (
    <ReviewOutcomeSummary
      subject="submission"
      status={submission.status}
      reviewedByName={submission.reviewedByName}
      reviewedAt={submission.reviewedAt}
      reviewerComment={submission.reviewerComment}
    />
  );
}
